import { SettingFormItem } from "../../types"
import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as React from "react"
import { Checkbox, Form } from "antd"

type Props = {
    settings: SettingFormItem
    key: string
    stateKey: string
    stateFieldValue: boolean
    label: Maybe<React.ReactNode>
    style?: React.CSSProperties
    className?: string
    helperText?: Maybe<string>
    helperTextStyle?: React.CSSProperties
    onChangeCallback: () => void
    onStateValueChanged: (stateKey: string, value: Maybe<any>) => void
}

export const InputOnOffCheckbox = (props: Props) => {
    const formItemLayout2 = {
        colon: false,
        labelCol: {
            xs: {
                span: 22,
            },
            sm: {
                span: 22,
            },
        },
        wrapperCol: {
            xs: {
                span: 2,
            },
            sm: {
                span: 2,
            },
        },
    }
    const settings = Object.assign({}, props.settings)
    return (
        <div>
            <Form.Item
                className={props.className}
                style={{
                    marginBottom: "0rem",
                    ...(props.style ?? {}),
                }}
                {...formItemLayout2}
                label={props.label}>
                <Checkbox
                    onChange={e => {
                        props.onStateValueChanged(props.stateKey, e.target.checked)
                        if (settings[props.key]) {
                            settings[props.key].indeterminate = false
                        }
                        props.onChangeCallback()
                    }}
                    indeterminate={settings[props.key]?.indeterminate}
                    checked={settings[props.key]?.indeterminate ? undefined : props.stateFieldValue}
                />
            </Form.Item>
            {props.helperText && (
                <div
                    style={{
                        position: "relative",
                        bottom: "0.9rem",
                        paddingLeft: "1rem",
                        paddingRight: "5rem",
                        lineHeight: "1.3",
                        ...(props.helperTextStyle || {}),
                    }}>
                    <span
                        style={{
                            fontSize: "12px",
                            color: "#7E7E7E",
                        }}>
                        {props.helperText}
                    </span>
                </div>
            )}
        </div>
    )
}
